// extracted by mini-css-extract-plugin
module.exports = {"container":"whorwe_container__19idH","contentWrap":"whorwe_contentWrap__1Xxxz","accordionBg":"whorwe_accordionBg__3mvNY","imgWrap":"whorwe_imgWrap__zLFHW"};